//------------------------------------------------------------------------------
// マスター情報 オペレーション
//------------------------------------------------------------------------------
import backend from '@/common/backend';
import actions from './actions';

/**
 * マスター情報取得
 */
export function loadMasters() {
  return async (dispatch, getState) => {

    // マスター取得済の場合は処理終了
    const { master } = getState();
    if (master?.loaded) {
      return;
    }

    // マスター情報取得
    const res = await backend.get('login/master');

    // 汎用マスタをストアへ登録
    const genericMap = createGenericMap(res.body.genericMst);
    dispatch(actions.setGenericMap(genericMap));

    // 地区マスタをストアへ登録
    const areaList = res.body.areas;
    dispatch(actions.setAreaList(areaList));

    // マスタ取得状態更新
    dispatch(actions.setLoaded(true));
  };
}

// 汎用マスタ一覧をマップに変換
function createGenericMap(list = []) {
  const map = {};
  for (const data of list) {
    const categoryType = data.categoryType;
    if (!Object.hasOwn(map, categoryType)) {
      map[categoryType] = [];
    }
    map[categoryType].push(data);
  }
  return map;
}

// デフォルトエクスポート
export default {
  loadMasters,
};
